<template>
    <div class="boxed-navbar px-5">
        <img
            class="hover:cursor-pointer w-[130px]"
            @click="$router.push({ name: 'home' })"
            :src="asset('images/logo/logo-krisan-new.svg')"
        />
        <!-- <v-toolbar-title>Vuetify</v-toolbar-title> -->
        <v-spacer></v-spacer>
        <v-slide-x-reverse-transition leave-absolute>
            <HorizontalMenu
                v-if="$route.meta.layout == 'LayoutUser'"
                :menu="menu"
            ></HorizontalMenu>
        </v-slide-x-reverse-transition>
        <v-spacer></v-spacer>
        <v-slide-x-reverse-transition>
            <v-icon
                v-click-outside="closeIfOpen"
                v-if="$vuetify.display.mdAndDown"
                @click="openDrawer"
                class="text-primary mr-4"
                start
            >
                <span
                    :key="key"
                    v-if="drawer"
                    class="icon-[line-md--menu-to-close-alt-transition]"
                ></span>
                <span
                    :key="key"
                    v-if="!drawer"
                    class="icon-[line-md--close-to-menu-alt-transition]"
                ></span>
            </v-icon>
            <!-- <v-app-bar-nav-icon
                @click="openDrawer"
                class="text-white"
                v-if="$vuetify.display.width <= 1160"
            ></v-app-bar-nav-icon> -->
        </v-slide-x-reverse-transition>
        <!-- <template v-if="$vuetify.display.smAndUp"> -->
        <!-- <ThemeSwitcher></ThemeSwitcher> -->
        <!-- </template> -->
        <template v-if="$can('read', 'auth')">
            <AppBarUserMenu></AppBarUserMenu>
        </template>
        <template v-else>
            <!-- <v-btn
                v-if="$vuetify.display.lgAndUp"
                color="primary"
                variant="text"
                class="mr-2"
                :to="{ name: 'register' }"
                >Register</v-btn
            > -->
            <div class="w-[150px] text-right">
                <v-btn
                    color="primary"
                    variant="elevated"
                    :to="{ name: 'login' }"
                >
                    Login
                </v-btn>
            </div>
        </template>
    </div>
</template>
<script setup>
// import menu from "@/menu.js";
import ThemeSwitcher from "./component/ThemeSwitcher.vue";
import HorizontalMenu from "./component/HorizontalMenu.vue";
import AppBarUserMenu from "./component/AppBarUserMenu.vue";
import { asset } from "@/mixins";
import { ref, watch } from "vue";

const props = defineProps(["drawer", "menu", "countMenu", "admin"]);
const emit = defineEmits(["emitDrawer"]);
const openDrawer = () => {
    emit("emitDrawer");
    key.value += 1;
};

const closeIfOpen = () => {
    if (props.drawer && props.admin) {
        emit("emitDrawer");
    }
};

const key = ref(false);
watch(
    () => props.drawer,
    () => {
        key.value += 1;
    }
);
</script>
